const YandexMapsLoader = () => {
	return new Promise((resolve, reject) => {
		window.ymaps.ready(resolve);
	});
};

export default YandexMapsLoader;
